import { RowSelectionState as ReactTableRowSelectionState } from '@tanstack/react-table';

export function makeRowSelectionState(selectedRowIndices: number[]): ReactTableRowSelectionState {
  return Object.fromEntries(selectedRowIndices.map((x) => [x, true]));
}
